import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import Alert from "./Alert"
import AlertDialog from "./AlertDialog"
import Button from "./Button"

export function WalletBannedDialog({
  open,
  onAbort,
  onBypass,
  onRetry,
  variant = "blocked",
}: {
  open: boolean
  onAbort: () => void
  onBypass: () => void
  onRetry?: () => void
  /** `blocked` — wallet is definitively unsafe (default).
   *  `unreachable` — safety check failed transiently; retry is available. */
  variant?: "blocked" | "unreachable"
}) {
  const isUnreachable = variant === "unreachable"
  return (
    <AlertDialog open={open}>
      <div className="mt-4 flex flex-col items-center">
        <div className="flex size-13 items-center justify-center rounded-full bg-yellow-100">
          <ExclamationTriangleIcon className="size-6 text-yellow-600" />
        </div>
        <AlertDialog.Title className="mt-5">
          {isUnreachable
            ? "Safety check unavailable"
            : "Unsupported wallet address"}
        </AlertDialog.Title>
        <AlertDialog.Description className="mt-2">
          {isUnreachable
            ? "We couldn't verify your wallet right now. Check your connection and try again."
            : "For your safety, your wallet address cannot be used with this app."}
        </AlertDialog.Description>

        {!isUnreachable && (
          <Alert variant="info" className="mt-5">
            Your wallet address was created before EVM support was added to
            NEAR. Please use a different wallet to continue.
          </Alert>
        )}
      </div>

      <div className="mt-5 flex flex-col gap-2">
        {isUnreachable && onRetry != null && (
          <Button size="xl" fullWidth onClick={onRetry} variant="primary">
            Try again
          </Button>
        )}
        <Button
          size="xl"
          fullWidth
          onClick={onAbort}
          variant={isUnreachable ? "secondary" : "primary"}
        >
          Disconnect
        </Button>
        <Button
          size="xl"
          fullWidth
          onClick={onBypass}
          variant="destructive-soft"
        >
          Proceed anyway, I know what I&apos;m doing
        </Button>
      </div>
    </AlertDialog>
  )
}
